import { PaletteOptions } from '@mui/material/styles'

// Professional color palette inspired by financial dashboards
export const palette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#1565c0', // Professional blue
    light: '#5e92f3',
    dark: '#003c8f',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#37474f', // Dark blue-grey
    light: '#62727b',
    dark: '#102027',
    contrastText: '#ffffff',
  },
  error: {
    main: '#d32f2f',
    light: '#ef5350',
    dark: '#c62828',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#ed6c02',
    light: '#ff9800',
    dark: '#e65100',
    contrastText: '#ffffff',
  },
  info: {
    main: '#0288d1',
    light: '#03a9f4',
    dark: '#01579b',
    contrastText: '#ffffff',
  },
  success: {
    main: '#2e7d32',
    light: '#4caf50',
    dark: '#1b5e20',
    contrastText: '#ffffff',
  },
  grey: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },
  background: {
    default: '#fafafa',
    paper: '#ffffff',
  },
  text: {
    primary: 'rgba(0, 0, 0, 0.87)',
    secondary: 'rgba(0, 0, 0, 0.6)',
    disabled: 'rgba(0, 0, 0, 0.38)',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  action: {
    active: 'rgba(0, 0, 0, 0.54)',
    hover: 'rgba(0, 0, 0, 0.04)',
    selected: 'rgba(0, 0, 0, 0.08)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    focus: 'rgba(0, 0, 0, 0.12)',
  },
}

// Custom color tokens for specific use cases
export const customColors = {
  // Metal colors for visual coding
  metals: {
    AU: '#ffd700', // Gold
    AG: '#c0c0c0', // Silver
    CU: '#b87333', // Copper
    PGM: '#e5e4e2', // Platinum
  },
  // Project stage colors
  stages: {
    PRE_DISCOVERY: '#f44336',
    BROWNFIELD_EXPLORATION: '#ff9800',
    MAIDEN_MRE: '#ffeb3b',
    SCOPING_PEA: '#8bc34a',
    PFS: '#4caf50',
    FS: '#009688',
    FID_BUILD: '#2196f3',
  },
  // Data visualization colors
  charts: {
    primary: '#1565c0',
    secondary: '#37474f',
    tertiary: '#0288d1',
    quaternary: '#2e7d32',
    accent: '#ed6c02',
  },
  // Status colors
  status: {
    active: '#4caf50',
    inactive: '#9e9e9e',
    pending: '#ff9800',
    error: '#f44336',
  },
}